import { StyledLogo } from '@/components/styles'
import { ActiveLink } from '@/components'

export default function Logo({ theme = 'default', ...props }) {
  return (
    <ActiveLink href="/" as="/">
      <StyledLogo theme={theme}>
        <img src="/images/logo.jpeg" alt="Sante" height={54} width={237}/>
      </StyledLogo>
    </ActiveLink>
  )
}
